import classNames from "classnames";
import React from "react";
import { useDispatch } from "react-redux";
import { closePopup } from "../../redux/actions/modal";

export default function ({ className, onClick }) {
  const dispatch = useDispatch();

  const closeHandler = (e) => {
    e.preventDefault();

    if (typeof onClick === "function") {
      return onClick(e);
    }

    return dispatch(closePopup());
  };

  return (
    <button
      className={classNames("custom-cross-btn", { [className]: !!className })}
      onClick={closeHandler}
    ></button>
  );
}
